import React from 'react';

import style from './TimeInputSelect.module.scss';

import { InputMask, MaskedInput } from '@components/Input';

import { TimeData } from '../types';
import { formatTimeValue, getTimeFromInputValue, fixMinMaxTime } from './utils/timeInputValue';

export interface TimeInputSelectProps {
    title?: string;
    disabled?: boolean;
    dataTest?: string;
    name?: string;
    time?: TimeData;
    allowEndOfDay?: boolean;
    minTime?: TimeData;
    maxTime?: TimeData;
    onSelect(time: TimeData, name?: string): void;
}

export function TimeInputSelect({
    title,
    disabled,
    dataTest = 'timeInputSelect',
    name,
    time,
    allowEndOfDay,
    minTime,
    maxTime,
    onSelect,
}: TimeInputSelectProps) {
    const handleTimeChange = ({ target: { value } }: React.FocusEvent<HTMLInputElement>): void => {
        const parsedTime = getTimeFromInputValue(value, allowEndOfDay);
        onSelect(fixMinMaxTime(parsedTime, minTime, maxTime), name);
    };

    return (
        <div className={style.root}>
            {disabled && <div className={style.disable_mask} />}
            <MaskedInput
                title={title}
                value={time ? formatTimeValue(time) : ''}
                disabled={disabled}
                dataTest={dataTest}
                mask={InputMask.Time}
                onBlur={handleTimeChange}
            />
        </div>
    );
}
